import { types } from 'mobx-state-tree'
import { STATES } from "~/utilities/constants";

// Checkout.com payments

const CKOStore = types
  .model('CKOStore', {
    isReady: types.optional(types.boolean, false),
    isValid: types.optional(types.boolean, false),
    billingAddressLine1: types.optional(types.string, ""),
    billingAddressLine2: types.optional(types.string, ""),
    billingAddressZip: types.optional(types.string, ""),
    billingAddressCity: types.optional(types.string, ""),
    billingAddressState: types.optional(types.string, STATES.NY),
    billingAddressCountry: types.optional(types.string, "United States"),
    savedCards: types.optional(types.array(types.frozen()), []),
    evSelectedCardId: types.optional(types.string, ""),
    evSelectedCardCvv: types.optional(types.string, ""),
    token: types.optional(types.string, ""),
    cardScheme: types.optional(types.string, ""),
    last4: types.optional(types.string, ""),
  })
  .actions(self => ({
    reset() {
      self.isReady = false
      self.isValid = false
      self.billingAddressLine1 = ""
      self.billingAddressLine2 = ""
      self.billingAddressZip = ""
      self.billingAddressCity = ""
      self.billingAddressState = STATES.NY
      self.billingAddressCountry = "United States"
      self.savedCards = []
      self.token = ""
      self.cardScheme = ""
      self.last4 = ""
    },
    teardown() {
      self.reset()
    },
    setField(field, value) {
      self[field] = value
    },
    setIsValid(value) {
      self.isValid = value
    },
    setIsReady(value) {
      self.isReady = value
    },
      setSavedCards(cards, forceIndexId = true) {
          // savedMethods/all answers `{}` when the user has no saved cards.
          if (!Array.isArray(cards)) {
              self.savedCards = []
              return
          }
          self.savedCards = cards.map((card, index) => ({
              ...card,
              id: forceIndexId ? `card-${index}` : card.id,
          }));
      },
    validateForm() {
      // Not implemented
    },
    tokenize() {
      return Promise.resolve(self.token)
    },
  }))

export default CKOStore
